import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApi } from "../use-api";

interface UpdateArgusInstanceInput {
  instanceId: string;
}

export function useUpdateArgusInstance() {
  const queryClient = useQueryClient();
  const { callApi } = useApi<void>();

  return useMutation({
    mutationFn: async (input: UpdateArgusInstanceInput) => {
      await callApi(`/client/argus/instances/${input.instanceId}/update`, {
        method: "POST",
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          typeof query.queryKey[0] === "string" &&
          query.queryKey[0].startsWith("/client/argus/instances"),
      });
      queryClient.invalidateQueries({
        queryKey: [`/client/argus/instances/${variables.instanceId}`],
      });
    },
  });
}
